import React from "react";

export default function Ex2_Intro() {
  return (
    <div>
      <h1>Ex2_Intro</h1>
      <p>This is the Ex2_Intro component.</p>
    </div>
  );
}
